import "./style.css";
import React from "react";
import Row from "../Row"

function PortfolioBlock(props) {
    return (
        <div className="item">
            <Row>
                <div className="col-md-6">
                    <h3>{props.props.position} {props.props.link ? <a href={props.props.link} target="_blank" rel="noopener noreferrer">[Link]</a> : null}</h3>
                    <p className="text-muted"><strong>{props.props.location}</strong></p>
                </div>
                <div className="col-md-6"><span className="period">{props.props.time}<br /></span></div>
            </Row>
            <p className="text-muted" style={{whiteSpace: "pre-wrap"}}>{props.props.description.map(element => {
                return(<p>· {element}</p>)
            })}</p>
            <p className="text-muted"><strong>Skills: {props.props.skills.map(skill => {
                if (props.props.skills[props.props.skills.length - 1] === skill) {
                    return(<>{skill}</>)
                }
                return(<>{skill}  · </>)
            })}</strong></p>
        </div>
    );
}

export default PortfolioBlock;
